import moment from 'moment';

function dayOfYear(now: Date = new Date()) {
  const start = new Date(now.getFullYear(), 0, 0);
  const diff =
    now.getTime() -
    start.getTime() +
    (start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000;
  const oneDay = 1000 * 60 * 60 * 24;
  return Math.ceil(diff / oneDay);
}
function getWeekNumber(date: Date) {
  return Number(moment(date).format('w'));
}

export const getDataset = ({
  name,
  minValue = 0,
  multiplier = 1000,
}: {
  name: string;
  minValue?: number;
  multiplier?: number;
}) => {
  const currentYear = new Date().getFullYear();
  const firstDayInYearMs = new Date(currentYear, 0, 0).getTime();
  const msInDay = 86400000;

  return new Array(dayOfYear()).fill(null).map((_, day) => {
    return {
      name,
      date: new Date(firstDayInYearMs + day * msInDay),
      value: Number((minValue + Math.random() * multiplier).toFixed(2)),
    };
  });
};

export const byDay = (data: ReturnType<typeof getDataset>) => {
  return data.map((item) => ({ ...item, date: moment(item.date.getTime()).format('DD.MM') }));
};

export const byWeek = (data: ReturnType<typeof getDataset>) => {
  const result: typeof data = [];
  data.forEach((mutableItem) => {
    const item = { ...mutableItem };
    if (!result.length) {
      result.push(item);
      return null;
    }
    const lastInResult = result[result.length - 1];
    if (getWeekNumber(lastInResult.date) === getWeekNumber(item.date)) {
      lastInResult.value = Number((lastInResult.value + item.value).toFixed(2));
    } else {
      result.push(item);
    }
    return null;
  });
  return result.map((item) => ({ ...item, date: moment(item.date.getTime()).format('DD.MM') }));
};

export const byMonth = (data: ReturnType<typeof getDataset>) => {
  const result: typeof data = [];
  data.forEach((mutableItem) => {
    const item = { ...mutableItem };
    if (!result.length) {
      result.push(item);
      return null;
    }
    const lastInResult = result[result.length - 1];
    if (lastInResult.date.getMonth() === item.date.getMonth()) {
      lastInResult.value = Number((lastInResult.value + item.value).toFixed(2));
    } else {
      result.push(item);
    }
    return null;
  });
  return result.map((item) => ({ ...item, date: moment(item.date.getTime()).format('MMMM') }));
};
